import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

const faqs = [
  {
    q: "Qual e' la durata minima dell'abbonamento?",
    a: "L'abbonamento ha una durata minima di 6 mesi. Questo ci permette di impostare una strategia solida, implementarla e iniziare a vedere i primi risultati concreti. Il marketing digitale richiede tempo per costruire risultati duraturi.",
  },
  {
    q: "Cosa include il piano da 249 euro al mese?",
    a: "Il piano base include la gestione completa della comunicazione aziendale: strategia social media, creazione contenuti, gestione campagne pubblicitarie, email marketing e copywriting. In piu', ricevi in omaggio un sito web in abbonamento incluso nel prezzo.",
  },
  {
    q: "Il sito web in omaggio e' davvero gratuito?",
    a: "Si, il sito web e' incluso nel tuo abbonamento senza costi aggiuntivi. Viene progettato, sviluppato e mantenuto dal nostro team. Finche' il tuo abbonamento e' attivo, il sito e' tuo e completamente gestito da noi.",
  },
  {
    q: "Posso disdire dopo i 6 mesi iniziali?",
    a: "Assolutamente si. Dopo il periodo minimo di 6 mesi, l'abbonamento si rinnova mensilmente e puoi disdire in qualsiasi momento con un preavviso di 30 giorni. Nessun vincolo aggiuntivo.",
  },
  {
    q: "Come funziona la prima call gratuita?",
    a: "La call di approfondimento e' senza impegno e dura circa 30 minuti. Analizziamo insieme la tua situazione attuale, i tuoi obiettivi e ti proponiamo un piano d'azione personalizzato. Non c'e' nessun obbligo di acquisto.",
  },
  {
    q: "Lavorate solo con aziende della mia zona?",
    a: "No, siamo un'agenzia full remote. Lavoriamo con aziende in tutta Italia e anche con clienti internazionali grazie ai nostri servizi di Digital Export. La nostra rete di professionisti copre tutto il territorio nazionale.",
  },
  {
    q: "Che tipo di risultati posso aspettarmi?",
    a: "I risultati dipendono dal settore e dagli obiettivi, ma i nostri clienti vedono in media un aumento del 340% nella visibilita' online e una crescita significativa dei contatti qualificati gia' nei primi 3-4 mesi di lavoro.",
  },
  {
    q: "Utilizzate l'intelligenza artificiale?",
    a: "Si, integriamo l'AI in tutti i nostri processi: dall'analisi dei dati e dei competitor, all'ottimizzazione delle campagne, fino alla creazione di contenuti. L'AI ci permette di essere piu' rapidi, precisi e di massimizzare il ritorno sull'investimento.",
  },
];

export default function FaqSection() {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32" style={{ background: '#F8FAFC' }}>
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-3xl">
        <div className="text-center mb-12">
          <p className="text-xs font-medium text-[#1B4332] uppercase tracking-wider mb-3">FAQ</p>
          <h2 className="text-3xl md:text-5xl font-semibold tracking-tight mb-4" style={{ fontFamily: 'Outfit', color: '#0F172A' }}>
            Domande Frequenti
          </h2>
          <p className="text-base md:text-lg text-slate-600 leading-relaxed">
            Tutto quello che devi sapere sul nostro servizio e le condizioni di abbonamento.
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="bg-white rounded-xl border border-slate-100 px-6 shadow-sm data-[state=open]:shadow-md transition-shadow"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left text-sm font-semibold text-slate-900 hover:no-underline py-5">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-slate-600 leading-relaxed pb-5">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
